import { createWebHistory, createRouter } from 'vue-router'

import IndexView from './views/Index.vue'
import LocationsView from './views/Locations.vue'

const routes = [
    { path: '/', component: IndexView },
    { path: '/locations', component: LocationsView },
    { path: '/:pathMatch(.*)*', component: IndexView },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
